// extracted by mini-css-extract-plugin
export default {"grid":"Pm6vI1udGdXDWKo67zbX"};